// import { filter } from 'lodash'

export default function () {
  const professionalParams = window.location.href.toString().split('/')
  this.cnpj = professionalParams[3]
  if (!this.cnpj) {
    return
  }

  if (window.location.href !== null) {
  }
  this.professionalQRCodeURL = window.location.href

  if (!this.cnpj) {
    return
  }

  this.checkDomainOperator()
}



// WEBPACK FOOTER //
// ./src/app/patient/profile-company/gadget/resources/mounted.js